export default "__VITE_ASSET__5ff2d3d7__"